module.exports = __webpack_public_path__ + "img/1696556942898-image.jpg.3d93ec07.webp";